import { AnimatedModal } from 'components/AnimatedModal/AnimatedModal';
import { IdVerificationSummaryCard } from 'components/IdVerificationSummaryCard/IdVerificationSummaryCard';

export const IdVerificationModal = ({ idvSummary, visible = false, onClose = () => {} }) => {
  return (
    <AnimatedModal title="ID Verification" visible={visible} onClose={onClose} small={true}>
      {idvSummary ? (
        <IdVerificationSummaryCard idvSummary={idvSummary} />
      ) : (
        <div>No ID verification data yet.</div>
      )}
    </AnimatedModal>
  );
};
